import { BUSSINESS_TRAVEL_CLASS, ECONOMY_TRAVEL_CLASS } from "constants/common";
import useOutsideAlerter from "hooks/useOutsideAlerter";
import React, { useRef, useState } from "react";
import { Popover } from "antd";

export default function TravellersAndClassSection({ getAllTravllersAndClass }) {
  const [state, setState] = useState({
    adultCount: 1,
    childCount: 0,
    infantCount: 0,
    travelClass: ECONOMY_TRAVEL_CLASS,
    totalTravellers: 1,
    isShowTravelClassSelectionSection: false,
  });

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, () => {
    // console.log("outside callback");
    // handleShowHideTravelClassSelection();
    setState({ ...state, open: false });
  });

  // handle Travel and Class section
  //handle adult count
  const handleAdultCount = (type) => {
    if (type === "increase") {
      setState({ ...state, adultCount: state.adultCount + 1 });
    } else {
      setState({ ...state, adultCount: state.adultCount - 1 });
    }
  };

  // handle child count
  const handleChildCount = (type) => {
    if (type === "increase") {
      setState({ ...state, childCount: state.childCount + 1 });
    } else {
      setState({ ...state, childCount: state.childCount - 1 });
    }
  };

  // handle infant count
  const handleInfantCount = (type) => {
    if (type === "increase") {
      setState({ ...state, infantCount: state.infantCount + 1 });
    } else {
      setState({ ...state, infantCount: state.infantCount - 1 });
    }
  };

  // handle travel class count
  const handleTravelClass = (classType) => {
    setState({ ...state, travelClass: classType });
  };

  const handleShowHideTravelClassSelection = () => {
    setState({
      ...state,
      isShowTravelClassSelectionSection: false,
    });
  };

  const handleApply = () => {
    let totalTravellers =
      state.childCount + state.infantCount + state.adultCount;
    // let travellersandClassTypes = {
    //   totalTravllers: totalTravllers,
    //   travelClasstype: state.travelClass,
    // };
    console.log("totalTravellers", totalTravellers);
    setState({
      ...state,
      totalTravellers: totalTravellers,
      isShowTravelClassSelectionSection: false,
      open:false
    });
    let travllersAndClass = {
      travelClass: state.travelClass,
      noOfTravellerType: [
        {
          type: "adult",
          members: state.adultCount,
        },
        {
          type: "children",
          members: state.childCount,
        },
        {
          type: "infant",
          members: state.infantCount,
        },
      ],
    };
    getAllTravllersAndClass(travllersAndClass);
  };

  let { adultCount, childCount, infantCount, travelClass } = state;
  return (
    <div className="search-left-content cursor-pointer">
      <Popover
        trigger="click"
        placement="bottom"
        open={state.open}
        overlayClassName="travel-popover-model"
        content={
          <div role="button" className="travel-class-section" ref={wrapperRef}>
            <div className="travel-class-content">
              <h5 className="text-uppercase section-heading">
                SELECT TRAVELLER & CLASS
              </h5>
              <div className="travel-class-list">
                <div className="travel-class-item">
                  <button
                    onClick={() => handleAdultCount("decrease")}
                    className="icon-minus"
                    disabled={state.adultCount === 1}
                  >
                    <i class="fa-solid fa-minus"></i>
                  </button>
                  <div className="travel-class-item-text">
                    <h5 className="color-primary font-weight-semibold mb-1">
                      {adultCount} Adult(s)
                    </h5>
                    <p className="mb-0 secondary-color font-size-14">
                      (12+ years)
                    </p>
                  </div>
                  <button
                    onClick={() => handleAdultCount("increase")}
                    disabled={state.adultCount >= 10}
                    className="icon-minus"
                  >
                    <i class="fa-solid fa-plus"></i>
                  </button>
                </div>
                <div className="travel-class-item">
                  <button
                    onClick={() => handleChildCount("decrease")}
                    className="icon-minus"
                    disabled={state.childCount === 0}
                  >
                    <i class="fa-solid fa-minus"></i>
                  </button>
                  <div className="travel-class-item-text">
                    <h5 className="color-primary font-weight-semibold mb-1">
                      {childCount} Child(ren)
                    </h5>
                    <p className="mb-0 secondary-color font-size-14">
                      (2 - 12 years)
                    </p>
                  </div>
                  <button
                    onClick={() => handleChildCount("increase")}
                    className="icon-minus"
                    disabled={state.childCount >= 5}
                  >
                    <i class="fa-solid fa-plus"></i>
                  </button>
                </div>
                <div className="travel-class-item">
                  <button
                    onClick={() => handleInfantCount("decrease")}
                    className="icon-minus"
                    disabled={state.infantCount === 0}
                  >
                    <i class="fa-solid fa-minus"></i>
                  </button>
                  <div className="travel-class-item-text">
                    <h5 className="color-primary font-weight-semibold mb-1">
                      {infantCount} Infant(s)
                    </h5>
                    <p className="mb-0 secondary-color font-size-14">
                      (Below 2 years)
                    </p>
                  </div>
                  <button
                    onClick={() => handleInfantCount("increase")}
                    className="icon-minus"
                    disabled={state.infantCount >= 5}
                  >
                    <i class="fa-solid fa-plus"></i>
                  </button>
                </div>
              </div>
              <h5 className="text-uppercase section-heading-bottom">
                CHOOSE TRAVEL CLASS
              </h5>
              <div className="button-list text-center">
                <button
                  onClick={() => handleTravelClass(ECONOMY_TRAVEL_CLASS)}
                  className={`btn btn-outline  ${
                    travelClass === ECONOMY_TRAVEL_CLASS && "active-class-type"
                  }`}
                >
                  Economy Class
                </button>
                <button
                  onClick={() => handleTravelClass(BUSSINESS_TRAVEL_CLASS)}
                  className={`btn btn-outline ${
                    travelClass === BUSSINESS_TRAVEL_CLASS &&
                    "active-class-type"
                  }`}
                >
                  Business Class
                </button>
              </div>
              <button
                onClick={handleApply}
                className="btn-primary mt-md-4 mt-3"
              >
                Apply
              </button>
            </div>
          </div>
        }
      >
        <div
          onClick={() => {
            setState({ ...state, open: true });
          }}
          className="deprature-return-content border-none position-relative"
        >
          <div className="deprature-title d-flex">
            TRAVELLER & CLASS
            <span className="ml-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="10"
                viewBox="0 0 11 6"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M1.12508 0.528512C1.38562 0.268165 1.80802 0.268165 2.06855 0.528512L5.59959 4.05712L9.13064 0.528512C9.39116 0.268165 9.81358 0.268165 10.0741 0.528512C10.3346 0.788865 10.3346 1.21097 10.0741 1.47133L6.07132 5.47132C5.81081 5.73165 5.38838 5.73165 5.12787 5.47132L1.12508 1.47133C0.864556 1.21097 0.864556 0.788865 1.12508 0.528512Z"
                  fill="#118DFF"
                />
              </svg>
            </span>
          </div>
          <h3 className="deprature-date font-weight-bold d-flex align-items-end mb-0">
            {state.totalTravellers}{" "}
            <h6 className="font-weight-bold mb-1 ml-2">Traveler(s)</h6>
          </h3>
          <span className="font-size-14 font-weight-semibold ">
            {state.travelClass === "Business"
              ? "Bussiness Class"
              : "Economy Class"}
          </span>
          <br />
          <span className="font-size-12 font-weight-semibold ">
            {`${adultCount} Adults , ${childCount} Childs , ${infantCount} Infant`}
          </span>
        </div>
      </Popover>
    </div>
  );
}
